export default "__VITE_ASSET__DT3A3vGd__"